import type { ChainName, TargetId } from "@common/target/types"

export type TargetSlug = string

export type TargetCategory = "mainnet" | "beta" | "local" | "other"

export interface TargetInfo {
  /**
   * A unique string representing a specific target
   */
  id: TargetId
  /**
   * A user friendly name
   */
  name: string
  /**
   * A string used for URL's
   */
  slug: TargetSlug
  /**
   * A category representing how this target is used
   */
  category: TargetCategory
  /**
   * If `true`, the contract uses direct price updates instead of the Pyth oracle
   */
  directPriceUpdates: boolean
  /**
   * Should we hide this network from the network dropdown list?
   *
   * When enabled, the network will still appear on the stats page,
   * and will also support direct URLs.
   *
   */
  hideInNetworkList: boolean
}

interface MakeTargetInfoProps {
  id: TargetId
  slug: TargetSlug
  chain: ChainName
  category?: TargetCategory
  name?: string
  directPriceUpdates?: boolean
  hideInNetworkList?: boolean
}

const makeTargetInfo = (props: MakeTargetInfoProps): TargetInfo => {
  const { id, slug } = props

  return {
    id,
    slug,
    category: props.category ?? "other",
    name: props.name ?? id,
    directPriceUpdates: props.directPriceUpdates ?? false,
    hideInNetworkList: props.hideInNetworkList ?? false,
  }
}

/**
 * Organized for convenient display
 */
export const targetInfos: TargetInfo[] = [
  makeTargetInfo({
    id: "rujimainnet1",
    slug: "rujira",
    chain: "rujira",
    category: "mainnet",
    name: "Rujira",
  }),
  makeTargetInfo({
    id: "rujibeta",
    slug: "rujira-testnet",
    chain: "rujira",
    category: "beta",
    name: "Rujira Testnet",
  }),
  makeTargetInfo({
    id: "rujidev",
    slug: "rujira-devnet",
    chain: "rujira",
    category: "local",
    name: "Rujira Devnet",
  }),
]
